import axios from "axios";
import { toast } from "bulma-toast";

export function createPaypalBnt(getValues, onComplete, onCancelled) {
    const state = {
        orderID: null,
    };
    return window.paypal.Buttons({
        async createOrder(data, actions) {
            if (state.orderID != null) {
                return state.orderID;
            }
            try {
                const values = await getValues();
                const startDate = values.day + ' ' + values.heure;
                const response = await axios.post("/rdv/payment/create-order", {
                    startDate,
                    idAgenda: values.idAgenda,
                    idPrestation: values.idPrestation,
                    idLocation: values.idLocation,
                    groupSize: values.groupSize,
                    paymentProviderName: "paypal",
                });
                const body = response.data;
                state.orderID = body.id
                return body.id;
            } catch (error) {
                let message = error.response?.data?.message ?? error.message ?? "Le rendez-vous n'a pas pu être créé.";
                toast({
                    message,
                    type: "is-danger",
                    duration: 5000,
                    pauseOnHover: true,
                });
                return null;
            }
        },
        async onCancel(data) {
            state.orderID = null;
            try {
                await axios.delete("/rdv/payment/cancel-order/" + data.orderID);
            } catch (err) {
                console.error(err);
            }
        },
        async onApprove(data, actions) {
            const response = await axios.post("/rdv/payment/capture-payment/" + data.orderID);
            const captureData = await response.data;
            if (captureData.error === "INSTRUMENT_DECLINED") {
                console.log("INSTRUMENT_DECLINED :");
                return actions.restart();
            }
            console.log("order completed :");
            console.log(captureData);
            onComplete(data.orderID);
        },
        onError(err) {
            console.log(err);
            toast({
                message: err.message || "Le rendez-vous n'a pas pu être créé.",
                type: "is-danger",
                duration: 5000,
                pauseOnHover: true,
            });
        }
    });
}

export async function stripeHandlePayment(values) {
    try {
        const startDate = values.day + ' ' + values.heure;
        const response = await axios.post("/rdv/payment/create-order", {
            startDate,
            idAgenda: values.idAgenda,
            idPrestation: values.idPrestation,
            idLocation: values.idLocation,
            groupSize: values.groupSize,
            paymentProviderName: "stripe",
        });
        return response.data.url;
    } catch (error) {
        let message = error.response?.data?.message ?? error.message ?? "Le rendez-vous n'a pas pu être créé.";
        toast({
            message,
            type: "is-danger",
            duration: 5000,
            pauseOnHover: true,
        });
        return null;
    }
}